import { render, staticRenderFns } from "./ButtonCancel.vue?vue&type=template&id=a4333436&scoped=true&"
var script = {}
import style0 from "./ButtonCancel.vue?vue&type=style&index=0&id=a4333436&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4333436",
  null
  
)

export default component.exports